import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

const ConfirmModal = ({ isOpen, onConfirm, onCancel, message = 'Are you sure you want to delete this item? This action cannot be undone.' }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" data-testid="confirm-modal">
      <div className="bg-white border border-[#E5E7EB] max-w-sm w-full shadow-lg">
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#E5E7EB]">
          <div className="flex items-center gap-2">
            <AlertTriangle size={15} className="text-red-500" />
            <h3 className="font-semibold text-[#1F1F1F] text-sm">Confirm Delete</h3>
          </div>
          <button onClick={onCancel} className="text-[#9CA3AF] hover:text-[#6B7280] transition-colors">
            <X size={15} />
          </button>
        </div>
        <div className="px-5 py-4">
          <p className="text-sm text-[#4B5563] leading-relaxed">{message}</p>
        </div>
        <div className="px-5 pb-4 flex gap-2 justify-end">
          <button onClick={onCancel} className="px-4 py-2 border border-[#E5E7EB] text-sm text-[#374151] hover:bg-[#F5F7FA] transition-colors" data-testid="confirm-cancel-btn">
            Cancel
          </button>
          <button onClick={onConfirm} className="px-4 py-2 bg-red-600 text-white text-sm hover:bg-red-700 transition-colors" data-testid="confirm-delete-btn">
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
